import React, { Component } from 'react';
import {Link, Route, Redirect} from 'react-router-dom';
import './projects.css';
import Vimeo from '@u-wave/react-vimeo';
import MorePro from './morePro.js';




class Projects extends Component {
    constructor(){
        super();
        this.mapKeys={};
        this.stageTimer=null;
        this.vidSize=null;
        this.runTime=null;
        this.title = null;
        this.client = null;
        this.vidActive = false;
        this.state = {
            data:[],
            vidSize:0,
            fadeIn:false,
            vid:0,
            redirect:false
        }

    };


    componentDidMount(){
        var url = window.location.href
        this.getData(url);
        window.scrollTo(0,0);
        window.addEventListener('keydown', this.escape, false); 
      
    }

    componentWillUnmount(){
        window.removeEventListener('mousemove', this.resetFade);
        window.removeEventListener('scroll', this.resetFade, true);
        window.removeEventListener('keydown', this.resetFade);
        window.removeEventListener('keydown', this.escape, false); 
        window.clearTimeout(this.runTime)
        window.clearTimeout(this.stageTimer)
        this.props.vidPause();
        this.props.dePro();
        this.props.changeMeta()
        
    }
    escape=(e)=>{
        this.mapKeys[e.key] = e.type === 'keydown';
        if( e.key==="Escape"){
            this.setState({redirect:true});
    
        }
        else{this.resetFade();}
       
       
    }

    changeVid=(e,slug)=>{
        if(e !== this.state.vid)
        {
            this.getNewData(slug)
        }
    }

    getSize = () =>{
        if(this.vidSize){
            this.setState({vidSize: this.vidSize.clientWidth})
        }
    }
    getData = (url) => {
    
        var curr = url.split('/')[4];
        fetch((`/api/single?slug=${curr}`))
        .then(res => res.json())
        .then(data => this.setState({
            data: data.data, vid:data.data[0].id},()=>{
                this.runText();
                this.getSize();
                this.changeMeta();
                
            }));

  
      }
      getNewData = (slug) => {
    
        fetch((`/api/single?slug=${slug}`))
        .then(res => res.json())
        .then(data => this.setState({
            data: data.data, vid:data.data[0].id},()=>{
                this.getSize();
                window.scrollTo(0,0);
                this.changeMeta();
                
            }));

  
      }

      changeMeta=()=>{
          var type = "Music Video"
          if(this.state.data[0].type === "short"){
              type = "Short Film"
          }
          else if(this.state.data[0].type==="commercial"){
              type = "Commercial"
          }
          var title = `${this.state.data[0].title} — ${this.state.data[0].client} / ${type} Directed by David M. Helman`
          var des = this.state.data[0].details
          title = this.props.titleCase(title)
          this.props.changeMeta(title,des)
      }

      runText=()=>{
          var el = document.getElementsByClassName('marqueeHold')
          if(el){
             for(var i = 0;i < el.length;i++){
              el[i].style.top = (parseInt(el[i].style.top, 10) - 1)+"px"
              if((parseInt(el[i].style.top, 10) < ((this.props.win[1]-el[i].clientHeight-120)))&& (el.length < 2)){
                let clone = el[i].cloneNode(true);
                clone.style.top = ((this.props.win[1]+100)+"px");
                document.querySelector('#Marquee').appendChild( clone );

              }
              else if((parseInt(el[i].style.top, 10) < (-1*(el[i].clientHeight+200)))){
                el[i].parentNode.removeChild(el[i])

              }
             }
             
             this.runTime = setTimeout(this.runText, 7)
          }
        
      }
    
      fadeIn=()=>{
        this.setState({fadeIn:true})
      }
      resetFade=()=>{
            window.clearTimeout(this.stageTimer)
            this.props.vidPause();
            this.stageTimer = setTimeout(this.props.vidPlay, 3000)

      }

      fadeStage=()=>{
        this.stageTimer=setTimeout(this.props.vidPlay, 3000)
        window.addEventListener('mousemove', this.resetFade);
        window.addEventListener('scroll', this.resetFade, true);
      }
    
   

    render() {
        const { data } = this.state;
        const {win} = this.props;
        const {vid} = this.props;
        const {menu} = this.props;
        const {rep} = this.props;
        const {fadeIn} = this.state;
        const {redirect} = this.state;
        const {mobile} = this.props;
        const {night} = this.props;

    return (
        
    
      <React.Fragment>
          
                {redirect?(
                    <Redirect to="/" />
                ):("")}
        

                
                {data.length?(
                    <React.Fragment >
                            {data.map((item,i)=>{
                                return(
                                        <React.Fragment key={`projectItem-${i}`}>
                                        <div id={`proStage`} key={`project-${item.id}`} className={`singleProject fullWidth relative ${vid?"playing":""} ${fadeIn?"active":""} ${rep?"repsActive":""}`} style={{minHeight: win[1]}} onLoad={this.props.initPro.bind(this)}>
                                              <Link to="/"> 
                                               <div className="menuBack fullWidth fullHeight"></div></Link>
                                                {item.sections.length?(
                                                    item.sections.map((sec,s)=>{
                                                        return(
                                                        (sec.type==="video")?(
                                                            <React.Fragment key={`sec-${s}`}>
                                                            <div key={`sec-${s}`} className={`fullStage singleSec secVideo eCenter relative noEvent contain${sec.secRatio}`} style={{height:(win[0] > 600)?(win[1]):(win[1]*.8)}}>
                                                                {(s > 0)?(
                                                                    <div key={`video-${item.id}`} className={`centeredContent eFill projectContainer pjRatio${sec.secRatio}`} ref={element => this.vidSize = element}>
                                                                    {(this.state.vidSize > 0)?(
                                                                         <Vimeo key={`vimeo-${item.id}`}
                                                                         video={sec.vimeoLink}
                                                                         width="100%"
                                                                         height="100%"
                                                                         onReady={this.fadeIn}
                                                                         onPlay={this.fadeStage}
                                                                         className={`vimeo vimeo${sec.secRatio}`}
                                                            
                                     
                                                                         />
                                                                    ):('')}
                                                                   
                                                                    </div>
                                                                ):(
                                                                    <div key={`video-${item.id}`} className={`centeredContent eFill projectContainer pjRatio${sec.secRatio}`} ref={element => this.vidSize = element}>
                                                                    {(this.state.vidSize > 0)?(
                                                                         <Vimeo key={`vimeo-${item.id}`}
                                                                         video={sec.vimeoLink}
                                                                         width="100%"
                                                                         height="100%"
                                                                         onReady={this.fadeIn}
                                                                         onPlay={this.fadeStage}
                                                                         autoplay
                                                                         className={`vimeo vimeo${sec.secRatio}`}
                                                            
                                     
                                                                         />
                                                                    ):('')}
                                                                   
                                                                    </div>
                                                                )}
                                                                
                                                            </div>
                                                            {/* {(s===0)&&item.credits?(
                                                            <div className="fullWidth eCenter pbHuge credits" >
                                                                <div className="fullStage eCenter">
                                                                <div className="textStage eCenter secText tWhite" dangerouslySetInnerHTML={{ __html : item.about }}></div>
                                                                </div>
                                                            </div>
                                                        ):('')} */}
                                                            </React.Fragment>
                                                        ):(
                                                            <div key={`sec-${s}`} className="singleSec fullWidth">
                                                                {sec.media.length?(
                                                                    sec.media.map((images,m)=>{
                                                                        return(
                                                                            <img src={mobile?(this.props.getImg(images.name,800)):(this.props.getImg(images.name,2500))} className='fullImg' alt={`Still from "${this.props.titleCase(item.title)}", ${item.client?("for "+(this.props.titleCase(item.client))):('')} Directed by David M. Helman`}></img>
                                                                        )
                                                                    })
                                                                ):('')}
                                                                {(s===0)?(
                                                            <div className="fullStage ptLrg eCenter">
                                                                <div className="textStage secText tWhite eCenter" dangerouslySetInnerHTML={{ __html : item.about }}></div>
                                                            </div>
                                                        ):('')}
                                                    
                                                            </div>
                                                        )
                                                      
                                                        )
                                        
                                                    })
                                                ):('No Content Available')}
                                                {/* <div key={`vide-${item.id}`} className="fullStage eCenter ptLrg pbHuge" style={{minHeight: win[1]*.65}}>
                                                    <div className="textStage eCenter">
                                                        
                                                        <p className="tCaption tUpper tWhite fullWidth mbMed">More Videos</p>
                                                    </div>
                                                    <div className="fullWidth flex flexStretch">
                                                         <Route path='/work' render={()=><MorePro titleCase={this.props.titleCase} mobile={mobile} changeVid={this.changeVid} initCrawl={this.props.initCrawl} deCrawl={this.props.deCrawl} image={this.props.image} hover={this.props.hover} currID={data[0].id} getImg={this.props.getImg}  initPro={this.initPro}win={this.props.win}/>} />
                                                    </div>
                                                    
                                                </div> */}
                                        </div>
                                        <div key={`vide-${item.id}`} id="Marquee" className={`leftNav cPointer  ${vid?"playing":""} ${(rep || menu)?"hide":""}`} style={{height: win[1], width:'100px'}}>
                                        <Link to="/" className="fullWidth fullHeight">
                                        <div  className={`infoHolderL flex plMed prMed backBut flexAEnd pbMed`} style={{width:win[1], height:'100px'}}>                                       
                                            <h1 className="tBlack tUpper navBut">BACK</h1>
                                            <img src="/images/ui-back.svg" className="backIcon ptXs pbMed"/>  
                                            
                                        </div>
                                        </Link>
                                        <div className="marqueeHold fullWidth"  style={{top:win[1],height:((this.title && this.client)?((this.title.clientWidth+this.client.clientWidth)):win[1])}}>
                                            <div id="infoHolderL" className={`flex plMed prMed flexAEnd pbMed`} style={{width:((this.title && this.client)?((this.title.clientWidth+this.client.clientWidth+200)):win[1]), height:'100px'}}>
                                
                                                <h1 className="tBlack tUpper" ref={element => this.title = element }>{data[0].title}</h1>
                                                <h2 className="tBlack tUpper"ref={element => this.client = element }>{data[0].client}</h2>
                                        
                                    
                                
                                        </div>
                                </div>
                            </div>
                                </React.Fragment>              
                                )
                            })}
                        </React.Fragment>
                ):('')}
                

    
       </React.Fragment>
    
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/projects/projects.js